var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjibouti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 17.3913C14.6087 17.3913 4.69565 4.68406 4.68628 4.68631C7.58165 1.79088 11.5817 0 16 0C24.8365 0 32 7.1635 32 16L14.6087 17.3913Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 16C14.6087 16 4.69565 27.3159 4.68628 27.3137C7.58165 30.2091 11.5817 32 16 32C24.8365 32 32 24.8365 32 16H14.6087Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 4.68628C-1.56209 10.9347 -1.56209 21.0653 4.68628 27.3138C7.26834 24.7317 9.75166 22.2484 16 16L4.68628 4.68628Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47548 11.8262L7.51142 15.0147H10.8643L8.15192 16.9855L9.18779 20.1741L6.47548 18.2034L3.76304 20.1741L4.79917 16.9855L2.08679 15.0147H5.43942L6.47548 11.8262Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjibouti);
export default __webpack_public_path__ + "static/media/djibouti.76806f9b.svg";
export { ForwardRef as ReactComponent };